module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAATCAYAAACKsM07AAAAwElEQVRIS92VsQkCQRBF31cxMrIAA9HEwBJswMzLrECbsAAb0AZMRLADWzAwPDQwMz7zkQUPNhDuuGUNdpKFYf585v9ZRmZ2B4bAXtKab5hZBhyBVplr8D5kZltgDJwkHTyCKbAB2g0al5BcAeBa0AQIzGwOjICLpJvnQR9YAp1aWvwuyp3JBdADzpIWHsEK2AU0d9C3I5gAA+Aq6eURdIFZ4ATPBEwO1LgSHt+Df2xR3H9QKWJgQQJrGv0exL5oHwArX5QLyeRnAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/header/meun.png
// module id = Jh1y
// module chunks = 0